/**
 * Stormcaller ability clips. The clips themselves live in ../kits/stormcaller.ts; this file only
 * registers them. Abilities not registered there play the class defaults (../defaults.ts).
 */
import { registerStormcallerKit } from '../kits/stormcaller';

export function registerStormcallerClips(): void {
  registerStormcallerKit();
}
